import * as LabelPrimitive from '@radix-ui/react-label';
import type React from 'react';

import { cn } from '~/utils/cn.ts';

function Label({ className, ...props }: React.ComponentProps<typeof LabelPrimitive.Root>) {
	return (
		<LabelPrimitive.Root
			className={cn(
				// Base styles - Lyra style: text-xs
				'font-medium text-foreground text-xs',
				'leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70',
				className,
			)}
			data-slot="label"
			{...props}
		/>
	);
}

export { Label };
